"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATE_FORMAT_ALT = exports.DATE_FORMAT = exports.londonTZ = exports.months = exports.time = exports.MonthNumber = exports.Month = void 0;
var Month;
(function (Month) {
    Month["JANUARY"] = "January";
    Month["FEBRUARY"] = "February";
    Month["MARCH"] = "March";
    Month["APRIL"] = "April";
    Month["MAY"] = "May";
    Month["JUNE"] = "June";
    Month["JULY"] = "July";
    Month["AUGUST"] = "August";
    Month["SEPTEMBER"] = "September";
    Month["OCTOBER"] = "October";
    Month["NOVEMBER"] = "November";
    Month["DECEMBER"] = "December";
})(Month = exports.Month || (exports.Month = {}));
var MonthNumber;
(function (MonthNumber) {
    MonthNumber[MonthNumber["JANUARY"] = 1] = "JANUARY";
    MonthNumber[MonthNumber["FEBRUARY"] = 2] = "FEBRUARY";
    MonthNumber[MonthNumber["MARCH"] = 3] = "MARCH";
    MonthNumber[MonthNumber["APRIL"] = 4] = "APRIL";
    MonthNumber[MonthNumber["MAY"] = 5] = "MAY";
    MonthNumber[MonthNumber["JUNE"] = 6] = "JUNE";
    MonthNumber[MonthNumber["JULY"] = 7] = "JULY";
    MonthNumber[MonthNumber["AUGUST"] = 8] = "AUGUST";
    MonthNumber[MonthNumber["SEPTEMBER"] = 9] = "SEPTEMBER";
    MonthNumber[MonthNumber["OCTOBER"] = 10] = "OCTOBER";
    MonthNumber[MonthNumber["NOVEMBER"] = 11] = "NOVEMBER";
    MonthNumber[MonthNumber["DECEMBER"] = 12] = "DECEMBER";
})(MonthNumber = exports.MonthNumber || (exports.MonthNumber = {}));
exports.time = Object.values(Month);
exports.months = exports.time;
exports.londonTZ = 'Europe/London';
exports.DATE_FORMAT = 'DD MMMM YYYY';
exports.DATE_FORMAT_ALT = 'DD/MM/YYYY';
